// ============================================
// MissionControl/MissionControl.hooks.js
// ============================================

import { useState } from 'react';
import { MISSION_TIERS } from './MissionControl.constants';

export const useMissionSelection = () => {
  const [selectedMission, setSelectedMission] = useState(null);
  const [missionTier, setMissionTier] = useState(MISSION_TIERS.SIMPLE);
  const [complexMissionMode, setComplexMissionMode] = useState(null);

  const resetSelection = () => {
    setSelectedMission(null);
    setComplexMissionMode(null);
  };

  const handleTierChange = (tier) => {
    setMissionTier(tier);
    setSelectedMission(null);
    setComplexMissionMode(null);
  };

  return {
    selectedMission,
    setSelectedMission,
    missionTier,
    setMissionTier,
    handleTierChange,
    complexMissionMode,
    setComplexMissionMode,
    resetSelection,
  };
};

export const useSquadSelection = () => {
  const [selectedSquadMembers, setSelectedSquadMembers] = useState([]);

  const toggleSquadMember = (soldier) => {
    const exists = selectedSquadMembers.find(s => s.id === soldier.id);
    if (exists) {
      setSelectedSquadMembers(selectedSquadMembers.filter(s => s.id !== soldier.id));
    } else {
      setSelectedSquadMembers([...selectedSquadMembers, soldier]);
    }
  };

  const clearSelection = () => {
    setSelectedSquadMembers([]);
  };

  return {
    selectedSquadMembers,
    setSelectedSquadMembers,
    toggleSquadMember,
    clearSelection,
  };
};